import React from 'react';
import {default as Button} from '@sinclair-digital/sbg-storyline-components/src/components/Button';
import {LoginErrorTypes} from './loginErrorTypes';
import {logout} from '../../js/logout';
import '@sinclair-digital/sbg-storyline-components/src/base/base.css';
import styles from './LoginError.css';

export interface LoginErrorProps {
    error: LoginErrorTypes;
    userReadableDescription: React.ReactNode;
    debugInfo?: Record<string, string>;
}

export const LoginError = ({error, userReadableDescription, debugInfo = {}}: LoginErrorProps): JSX.Element => (
    <div className={styles.LoginError}>
        <header className={styles.header}>
            <span className={styles.story}>Story</span><span className={styles.line}>Line</span>
        </header>
        <div className={styles.background}>
            <div className={styles.container}>
                <h4 className={styles.heading}>Login Error</h4>
                <p className={styles.userDescription}>{userReadableDescription}</p>
                <div className={styles.debugInfo}>
                    <div>Error Code: {error}</div>
                    <div>Time: {new Date().toISOString()}</div>
                    {Object.entries(debugInfo).map(([key, value]) =>
                        <div key={key}>{key}: {value}</div>
                    )}
                </div>
                <Button className={styles.logout} displayType="primary" onClick={logout}>Return to login</Button>
            </div>
        </div>
    </div>
);
